import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { visit } from 'unist-util-visit';
import { processTextWithMentions } from '../Mention/mentionUtils';
export const mentionPlugin = (options = {})=>{
    const mentionClassName = options.mentionClassName || 'mention';
    return (tree)=>{
        visit(tree, 'text', (node, index, parent)=>{
            if (!parent || index === null) return;
            const value = node.value;
            const segments = processTextWithMentions(value);
            // If there's only one segment and it's not a mention, no changes needed
            if (segments.length === 1 && !segments[0].isMention) {
                return;
            }
            // Create a list of new nodes to replace the text node
            const nodes = segments.flatMap((segment)=>{
                if (segment.isMention) {
                    // Check for trailing comma and separate it from the mention
                    const hasTrailingComma = segment.text.endsWith(',');
                    const mentionText = hasTrailingComma ? segment.text.slice(0, -1) : segment.text;
                    const mentionNode = {
                        type: 'mention',
                        value: mentionText,
                        children: [
                            {
                                text: ''
                            }
                        ],
                        data: {
                            hName: 'mention',
                            hProperties: {
                                mentionText: mentionText.slice(1),
                                className: mentionClassName
                            }
                        }
                    };
                    if (hasTrailingComma) {
                        return [
                            mentionNode,
                            {
                                type: 'text',
                                value: ','
                            }
                        ];
                    }
                    return mentionNode;
                } else {
                    return {
                        type: 'text',
                        value: segment.text
                    };
                }
            });
            // Replace the original node with our new nodes
            parent.children.splice(index, 1, ...nodes);
        });
    };
};
// Custom component to render mentions
export const MentionComponent = ({ mentionText, className, renderMention })=>{
    // If a custom render function is provided, use it
    if (renderMention) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: renderMention(mentionText)
        });
    }
    // Default mention rendering - preserve quotes in the display
    return /*#__PURE__*/ _jsxs("span", {
        className: className || 'mention',
        children: [
            "@",
            mentionText
        ]
    });
};
